module.exports = __webpack_public_path__ + "static/media/A_Hearts.304bb6ef.svg";